import { useTranslation } from "react-i18next";
import BarPlot from "../charts/BarPlot";
import DashboardBlockShell from "./DashboardBlockShell";
import BooleanStatsPanel from "./BooleanStatsPanel";
import CategoricalStatsPanel from "./CategoricalStatsPanel";

export default function Bloc3BlockSection({
  id,
  title,
  description,
  loading = false,
  error = null,
  itemsByField,
}) {
  const { t } = useTranslation();
  const rockBoolStats = itemsByField["bloc3.rockBool"]?.stats || null;
  const rockCategoryStats = itemsByField["bloc3.rockCategory"]?.stats || null;
  const mineralBoolStats = itemsByField["bloc3.mineralBool"]?.stats || null;
  const mineralCategoryStats =
    itemsByField["bloc3.mineralCategory"]?.stats || null;

  const rockBoolChartItems = [
    { category: t("common.yes", "Sí"), count: rockBoolStats?.yes || 0 },
    { category: t("common.no", "No"), count: rockBoolStats?.no || 0 },
  ];
  const rockCategoryChartItems = (rockCategoryStats?.items || []).map(
    (item) => ({
      category: item.category,
      count: item.count,
    })
  );
  const mineralBoolChartItems = [
    { category: t("common.yes", "Sí"), count: mineralBoolStats?.yes || 0 },
    { category: t("common.no", "No"), count: mineralBoolStats?.no || 0 },
  ];
  const mineralCategoryChartItems = (mineralCategoryStats?.items || []).map(
    (item) => ({
      category: item.category,
      count: item.count,
    })
  );

  return (
    <DashboardBlockShell
      id={id}
      title={title}
      description={description}
      loading={loading}
      loadingText={t("dashboard.blocks.bloc3.loading", "Carregant estadístiques de bloc3…")}
      error={error}
    >
      <div className="space-y-4">
        <div className="grid grid-cols-1 xl:grid-cols-2 gap-4">
          <BooleanStatsPanel
            title={t(
              "dashboard.blocks.bloc3.rockPresence",
              "Presència de roques o pedres"
            )}
            stats={rockBoolStats}
          />
          <CategoricalStatsPanel
            title={t("dashboard.blocks.bloc3.rockCategories", "Categories de roca")}
            stats={rockCategoryStats}
          />
          <BooleanStatsPanel
            title={t(
              "dashboard.blocks.bloc3.mineralPresence",
              "Presència de minerals"
            )}
            stats={mineralBoolStats}
          />
          <CategoricalStatsPanel
            title={t(
              "dashboard.blocks.bloc3.mineralCategories",
              "Categories de minerals"
            )}
            stats={mineralCategoryStats}
          />
        </div>

        <div className="grid grid-cols-1 xl:grid-cols-2 gap-4">
          <BarPlot
            title={t(
              "dashboard.blocks.bloc3.yesNoRocks",
              "Respostes sí/no sobre roques o pedres"
            )}
            items={rockBoolChartItems}
          />
          <BarPlot
            title={t(
              "dashboard.blocks.bloc3.rockCategoryDistribution",
              "Distribució de categories de roca"
            )}
            items={rockCategoryChartItems}
          />
          <BarPlot
            title={t(
              "dashboard.blocks.bloc3.yesNoMinerals",
              "Respostes sí/no sobre minerals"
            )}
            items={mineralBoolChartItems}
          />
          <BarPlot
            title={t(
              "dashboard.blocks.bloc3.mineralCategoryDistribution",
              "Distribució de categories de minerals"
            )}
            items={mineralCategoryChartItems}
          />
        </div>
      </div>
    </DashboardBlockShell>
  );
}
